import { createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../shared/utils/api.js'

// Fetch all reviews
export const fetchAllReviews = createAsyncThunk('reviews/fetchAllReviews',
    async (params = {}, { rejectWithValue }) => {
        try {
          const queryString = new URLSearchParams(params).toString()
          const url = `/v1/reviews/all${queryString ? `?${queryString}` : ''}`

          const response = await api.get(url)
          return response.data
        } catch (error) {
          return rejectWithValue(error.response?.data?.message || error.message)
        }
      }
)

// Fetch single review by ID
export const fetchReviewById = createAsyncThunk(
  'reviews/fetchReviewById',
  async (reviewId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/reviews/${reviewId}`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Fetch reviews analytics
export const fetchReviewAnalytics = createAsyncThunk('reviews/fetchReviewAnalytics',
    async (params = {}, { rejectWithValue }) => {
        try {
          const queryString = new URLSearchParams(params).toString()
          const url = `/v1/reviews/analytics${queryString ? `?${queryString}` : ''}`

          const response = await api.get(url)
          return response.data
        } catch (error) {
          return rejectWithValue(error.response?.data?.message || error.message)
        }
      }
)

// Mark review as opened
export const markReviewAsOpened = createAsyncThunk(
  'reviews/markReviewAsOpened',
  async (reviewId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/v1/reviews/${reviewId}/mark-opened`)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to mark review as opened'
      return rejectWithValue(errorMessage)
    }
  }
)

// Get review opened status
export const fetchReviewOpenedStatus = createAsyncThunk(
  'reviews/fetchReviewOpenedStatus',
  async (reviewId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/reviews/${reviewId}/mark-opened`)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch review opened status'
      return rejectWithValue(errorMessage)
    }
  }
)

// Create new review
export const createReview = createAsyncThunk(
  'reviews/createReview',
  async (reviewData, { rejectWithValue }) => {
    try {
      const response = await api.post('/v1/reviews', reviewData)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Update existing review
export const updateReview = createAsyncThunk(
  'reviews/updateReview',
  async ({ reviewId, reviewData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/v1/reviews/${reviewId}`, reviewData)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Delete review
export const deleteReview = createAsyncThunk(
  'reviews/deleteReview',
  async (reviewId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/v1/reviews/${reviewId}`)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Flag review
export const flagReview = createAsyncThunk(
  'reviews/flagReview',
  async ({ reviewId, flagData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/v1/reviews/${reviewId}/flag`, flagData)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to flag review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Vote on review
export const voteOnReview = createAsyncThunk(
  'reviews/voteOnReview',
  async ({ reviewId, voteData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/v1/reviews/${reviewId}/vote`, voteData)
      return { reviewId, ...response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to vote on review'
      return rejectWithValue(errorMessage)
    }
  }
)

// Get property reviews
export const fetchPropertyReviews = createAsyncThunk(
  'reviews/fetchPropertyReviews',
  async (propertyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/reviews/property/${propertyId}`)
      return { propertyId, reviews: response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch property reviews'
      return rejectWithValue(errorMessage)
    }
  }
)
